import { CompositionIdentification } from '../SubPages/Identification/Form';

export type CompositionApiPayload = Omit<
  CompositionIdentification,
  'base_model_type' | 'quantity'
>;

type PrepareCompositionApiPayloadParams = {
  payload: CompositionIdentification;
  fallbackBaseModelType?: string;
};

export const prepareCompositionApiPayload = ({
  payload,
  fallbackBaseModelType,
}: PrepareCompositionApiPayloadParams): {
  apiPayload: CompositionApiPayload;
  normalizedBaseModelType?: string;
} => {
  const payloadWithBase = { ...payload };
  const { base_model_type: baseModelType, ...apiPayloadWithoutBase } =
    payloadWithBase;

  const apiPayload = { ...apiPayloadWithoutBase } as CompositionApiPayload;
  const normalizedBaseModelType = baseModelType || fallbackBaseModelType;

  if (!apiPayload.external_unit_measure_key) {
    delete apiPayload.external_unit_measure_key;
  } else {
    delete apiPayload.unit_measure_id;
  }

  if (apiPayload.unit_measure_id === undefined) {
    delete apiPayload.unit_measure_id;
  }

  // This helper is also used by modal flows that carry quantity for budget insert.
  // Quantity must not be sent to composition create/update endpoints.
  delete (apiPayload as CompositionIdentification).quantity;

  if (normalizedBaseModelType === 'sienge') {
    delete apiPayload.classification_id;
    delete apiPayload.type_id;
  } else {
    delete apiPayload.external_classification_key;
    delete apiPayload.external_type_key;
  }

  delete apiPayload.external_classification_description;
  delete apiPayload.external_type_description;

  return {
    apiPayload,
    normalizedBaseModelType,
  };
};
